import { render, staticRenderFns } from "./Dids.vue?vue&type=template&id=264a798e&scoped=true&"
import script from "./Dids.vue?vue&type=script&lang=js&"
export * from "./Dids.vue?vue&type=script&lang=js&"
import style0 from "./Dids.vue?vue&type=style&index=0&id=264a798e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264a798e",
  null
  
)

export default component.exports